import isObject from 'lodash/isObject';
import { useCallback } from 'react';
import { ISliderItemAnimation, ISliderItemImage, ISliderItemVideo, TFlexAlignment, TPosition, TSliderItemMediaType } from '@components/typescript';
import SliderContent from '@components/Slider/SliderContent';
import SliderImage from '@components/Slider/SliderImage';
import SliderCanvasAnimation from '@components/Slider/SliderCanvasAnimation';
import styles from '@components/Slider/Slider.styles';
import VideoPlayer from '@components/Video/VideoPlayer';
import Heading from '@components/Heading/Heading';
import prepareURLByCMSLink from '@utils/prepareURLByCMSLink';
const isImageType = (item: TSliderItemMediaType): item is ISliderItemImage => (item as ISliderItemImage).type === 'image';
const isAnimationType = (item: TSliderItemMediaType): item is ISliderItemAnimation => (item as ISliderItemImage).type === 'animation';
const isVideoType = (item: TSliderItemMediaType): item is ISliderItemVideo => (item as ISliderItemVideo).type === 'video';
type PropsType = {
  item: ISliderItemImage | ISliderItemAnimation | ISliderItemVideo;
  isActive: boolean;
  titleHidden?: boolean;
  isDividedOnMobile?: boolean;
  isFirst?: boolean;
};
const SliderItem = ({
  item,
  isActive,
  titleHidden = false,
  isDividedOnMobile = false,
  isFirst = false
}: PropsType) => {
  const renderContent = useCallback((): JSX.Element => {
    if (isImageType(item)) {
      if (item.blur) return <SliderImage image={item.image} blur={item.blur} priority={isFirst ?? false} alt={item.content.title} />;
      return <SliderImage image={item.image} priority={isFirst ?? false} alt={item.content.title} />;
    }
    if (isAnimationType(item)) {
      return <SliderCanvasAnimation canvasImages={item.images} />;
    }
    if (isVideoType(item) && item.video) {
      return <div sx={styles.sliderImageContainer(false)}>
          <VideoPlayer video={item.video} playVideo={isActive} loop poster={item.thumbnailWithBlur} />
        </div>;
    }
    return <></>;
  }, [isActive, item]);
  const {
    link,
    buttonVerticalPosition,
    buttonHorizontalPosition,
    buttonText,
    buttonStyle,
    content: {
      title,
      description,
      textImg,
      titleColor,
      descriptionColor,
      vertical,
      horizontal,
      topText,
      topTextColor,
      additionalButton
    }
  } = item;
  const normalizeVertical = (type): TFlexAlignment => type === 'down' ? 'end' : type;
  const position: TPosition = {
    vertical: normalizeVertical(vertical),
    horizontal
  };
  return <div sx={styles.sliderContainer(isDividedOnMobile)} data-cy="SliderItem">
      {isDividedOnMobile && <div sx={styles.mobileSliderContent} data-testid="slider-item-mobile-slider-content">
          <Heading h={isFirst ? 1 : 2} display={3} pb={16} mobile align="center" color={titleColor}>
            {title}
          </Heading>
          <Heading h={4} headingType={4} mobile>
            {description}
          </Heading>
        </div>}

      {renderContent()}
      {!titleHidden && <SliderContent href={isObject(link) ? prepareURLByCMSLink(link) : link} title={title} description={description} position={position} topText={topText} topTextColor={topTextColor} titleColor={titleColor} descriptionColor={descriptionColor} buttonVerticalPosition={buttonVerticalPosition} buttonHorizontalPosition={buttonHorizontalPosition} buttonStyle={buttonStyle} textImg={textImg} buttonText={buttonText} additionalButton={additionalButton} isFirst={isFirst} />}
    </div>;
};
export default SliderItem;